export const serviceCode = {
  BAYARIND: "1083",
  DANA: "1084",
  SHOPEEPAY: "1085",
  LINKAJA: "1077",
};
